// extracted by mini-css-extract-plugin
export default {"infoCard":"infoCard_infoCard__CT9p8","dismissButton":"infoCard_dismissButton__Mx9p1"};